import { render, staticRenderFns } from "./KioskSpinner.vue?vue&type=template&id=c34fdf24&scoped=true"
import script from "./KioskSpinner.vue?vue&type=script&lang=js"
export * from "./KioskSpinner.vue?vue&type=script&lang=js"
import style0 from "./KioskSpinner.vue?vue&type=style&index=0&id=c34fdf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34fdf24",
  null
  
)

export default component.exports